/**
 * Tipo da cobrança no Gestão Click, deduzido da descrição pelo backend.
 *
 * O ERP não tem campo para isso e o plano de contas não separa mensalidade de implantação — os dois
 * planos de receita carregam os dois tipos. `UNKNOWN` não é falha de classificação: lançamento
 * avulso não é nem um nem outro, e a tela precisa dizer isso em vez de chutar.
 */
export enum ReceivableType {
  MONTHLY = 'monthly',
  INSTALLATION = 'installation',
  UNKNOWN = 'unknown',
}

/** Status da cobrança. Derivado de `liquidado`/`data_liquidacao` e do vencimento. */
export enum ReceivableStatus {
  PAID = 'paid',
  OPEN = 'open',
  OVERDUE = 'overdue',
}

/** Opção "todos" dos filtros. Não é valor de nenhum dos dois enums. */
export const RECEIVABLE_FILTER_ALL = 'all';

export const RECEIVABLE_TYPE_LABELS: Record<ReceivableType, { label: string; color: 'primary' | 'secondary' | 'default' }> = {
  [ReceivableType.MONTHLY]: { label: 'Mensalidade', color: 'primary' },
  [ReceivableType.INSTALLATION]: { label: 'Implantação', color: 'secondary' },
  [ReceivableType.UNKNOWN]: { label: 'Não identificado', color: 'default' },
};

export const RECEIVABLE_STATUS_LABELS: Record<ReceivableStatus, { label: string; color: 'success' | 'default' | 'error' }> = {
  [ReceivableStatus.PAID]: { label: 'Pago', color: 'success' },
  [ReceivableStatus.OPEN]: { label: 'Em aberto', color: 'default' },
  [ReceivableStatus.OVERDUE]: { label: 'Em atraso', color: 'error' },
};
